import { apiCall } from 'app/shared/lib/essette-api';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { autoinject } from 'aurelia-framework';
import { CaseService } from 'app/cm/services/case-service';
import { Toaster } from 'app/shared/lib/toaster';
import * as CM from 'app/cm/models/essette-api';

@autoinject()
export class SaveReasonForReferralCustomElement extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////

    protected isValid: boolean = false;
    public referralReason?: CM.ReferralReason;

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(
        private readonly service: CaseService,
        private readonly toaster: Toaster,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** IForm ****************************************************////

    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        const response = await this.saveReferralReason();
        this.reset();
        return response;
    }

    ////****************** Functions ***********************************************////

    public reset() {
        this.referralReason = {};
    }

    ////****************** Service Calls ********************************************////

    @apiCall
    public async saveReferralReason(): Promise<boolean> {
        if(!this.referralReason) return false;
        let isSuccessful = false;

        try {
            this.state.beginSave();
            const response = await this.service.saveReferralReason(this.referralReason);
            isSuccessful = response.isSuccessful;

        } catch(error) {
            throw error;
        } finally {
            this.toaster.standard.saved('cm:referral.reason.$long', isSuccessful);
            this.state.endSave();
            return true;
        }
    }

}
